import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { AuthRoutes, UserRoute } from '@core/constants/routes.const';
import { BaseComponent } from '@shared/components/base-component/base-component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-signup-mobile-phone',
  templateUrl: './signup-mobile-phone.component.html',
  styleUrls: ['./signup-mobile-phone.component.scss'],
})
export class SignUpMobilePhoneComponent extends BaseComponent implements OnInit, OnDestroy {
  readonly B2CSignUpPhone = AuthRoutes.SignUpPhoneNumberB2C;

  constructor(
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.subscriptions.add(
      this.msalBroadcastService.msalSubject$
        .pipe(
          filter((event: EventMessage) =>
            [
              EventType.LOGIN_SUCCESS,
              EventType.ACQUIRE_TOKEN_SUCCESS,
              EventType.SSO_SILENT_SUCCESS,
            ].includes(event.eventType),
          ),
        )
        .subscribe(() => {
          this.router.navigate([UserRoute.MyAccount, UserRoute.Profile], {
            queryParams: { mobileUser: 'created' },
          });
        }),
    );
  }
}
